/*
 * *****************************************************************************
 *  Copyright (C) 2020 Testsigma Technologies Inc.
 *  All rights reserved.
 *  ****************************************************************************
 */

export enum ElementLocatorType {
  xpath = "xpath",
  csspath = "csspath",
  id_value = "id_value",
  name = "name",
  link_text = "link_text",
  partial_link_text = "partial_link_text",
  class_name = "class_name",
  tag_name = "tag_name",
  accessibility_id = "accessibility_id"
}
